import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CameraCapture from "./pages/CameraCapture";
import LogInPage from "./pages/LogInPage";
import { Toaster } from "@/components/ui/toaster";
import ProtectedRoute from "./components/ProtectedRoute"

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LogInPage />} />
          <Route path="/capture" element={
            <ProtectedRoute>
              <CameraCapture />
            </ProtectedRoute>
            } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;